import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '../../state/state.service';

@Component({
  selector: 'app-button-order-view',

  templateUrl: './button-order-view.component.html',
  styleUrls: ['./button-order-view.component.scss'],
})
export class ButtonOrderViewComponent {
  @Input() rowData: any;

  constructor(private router: Router, private state: StateService) { }


  goToOrderView() {
    switch (this.state.snapshot.auth.acl[0]) {
      case 'shp':
        this.router.navigate(['shop', 'order', this.rowData.id]);
        break;
      case 'lab':
        this.router.navigate(['lab', 'order', this.rowData.id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/orders-in-progress/button-order-view/button-order-view.component.ts